<template>
  <div class="box box-align-center box-pack-between main">
    <div class="whiteBg height100 main-left">
      <sort-label-show
        title=""
        :list="questionList"
        @nodeClick="getNodeIds"
        @handleDragEnd="handleDragEnd"
        @createTag="createTagEvent"
        @delLabel="delLabel"
        ref="sortLabel"
      ></sort-label-show>
    </div>
    <div class="whiteBg height100 main-right">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="box box-align-center mt-input">
            <div class="mti-txt">题干：</div>
            <el-input v-model="ruleForm.stem" style="width: 70%" placeholder="请输入题干" clearable></el-input>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="box box-align-center mt-input">
            <div class="mti-txt">题型：</div>
            <el-select v-model="ruleForm.topicType" clearable placeholder="请选择题型">
              <el-option v-for="item in topicOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="box box-align-center mt-input">
            <div class="mti-txt">试题标签：</div>
            <el-select v-model="ruleForm.label" multiple clearable placeholder="请选择试题标签">
              <el-option v-for="item in labelOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px" :gutter="20">
        <el-col :span="20">
          <div class="box box-align-center mt-input">
            <div class="mti-txt">最后更新时间：</div>
            <el-date-picker
              v-model="sendTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              clearable
            >
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="box box-align-center box-pack-end mt-btns">
            <el-button type="primary" icon="el-icon-search" @click="getList()">查询</el-button>
            <el-button plain icon="el-icon-refresh" @click="resetList">重置</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-button type="primary" plain icon="el-icon-plus" @click="addOneQuestions">新增试题</el-button>
        <el-button type="primary" plain icon="el-icon-document-add" @click="enterQuestions">批量导入试题</el-button>
        <el-button type="danger" plain icon="el-icon-delete" @click="batchDeleteQuestions">批量删除</el-button>
      </el-row>
      <dy-table
        :columns="columns"
        style="margin-top: 12px"
        :table-data="tableData"
        ref="multipleTable"
        v-loading="tableLoading"
        :total="total"
        :page-num="currentPage"
        :page-size="10"
        @current-change="onCurrentChange"
        @selection-change="onSelectionChange"
        element-loading-text="加载中"
      ></dy-table>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="addVisible" width="60%" :close-on-click-modal="false">
      <el-form :model="ruleForm" :rules="rules" label-width="110px" label-position="right" ref="ruleForm">
        <el-form-item label="类别：">
          <el-select v-model="ruleForm.categoryId" placeholder="请选择类别">
            <el-option v-for="item in sortList" :key="item.id" :label="item.categoryName" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <div class="mt12">
          <el-form-item label="快捷词：">
            <el-input v-model="ruleForm.quickWord" style="width: 183px" placeholder="请输入快捷词"></el-input>
          </el-form-item>
        </div>
        <div class="mt12">
          <el-form-item label="状态：">
            <el-switch v-model="ruleForm.status"> </el-switch>
          </el-form-item>
        </div>
        <div class="mt12">
          <el-form-item label="回复内容：">
            <el-input v-model="ruleForm.replyContent" type="textarea" style="width: 400px" rows="4" placeholder="请输入回复内容"></el-input>
          </el-form-item>
        </div>
        <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px">
          <el-button type="primary" plain @click="submitForm('ruleForm')">保存</el-button>
          <el-button type="danger" plain @click="() => (addVisible = false)">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog :title="categoryTitle" :visible.sync="addCategoryVisible" width="50%" :close-on-click-modal="false">
      <el-form>
        <div class="mt12">
          <el-form-item label="分类名称：">
            <el-input v-model="categoryName" placeholder="请输入分类名称"></el-input>
          </el-form-item>
        </div>
        <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px">
          <el-button type="primary" plain @click="saveCategory">保存</el-button>
          <el-button type="danger" plain @click="() => (addCategoryVisible = false)">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="批量导入" :visible.sync="addExportVisible" width="50%" :close-on-click-modal="false">
      <export-more-file
        :tHeader="tHeader"
        :tValue="tValue"
        ref="exportMoreFile"
        @cancelData="
          () => {
            addExportVisible = false;
          }
        "
        @saveData="getData"
      ></export-more-file>
    </el-dialog>
  </div>
</template>
<script>
import DyTable from '@/components/common/dytable';
import ExportMoreFile from '@/components/common/exportMoreFile';
import sortLabelShow from '@/components/common/sortLabelShow/questionIndex';
import { subtractArrays, uniqueBy } from '@/utils/utils';
import {
  findFeedBack,
  findFeedBackCategory,
  editFeedBack,
  editFeedBackCategory,
  addFeedBackCategory,
  addFeedBackBatch,
  listQuestion,
  deleteQuestion,
  zgsourceAllCategory,
  list4Select,
  batchDelete,
  zgAddCategory,
  zgDeleteCategory,
} from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { formatDate } from '@/utils/utils';

var that = null;
export default {
  components: {
    DyTable,
    ExportMoreFile,
    sortLabelShow,
  },
  data() {
    const { editArticle } = this;
    const { delArticle } = this;
    return {
      sendTime: '',
      isChange: false,
      tableLoading: true,
      currentIndex: 0,
      dialogTitle: '新建弹窗',
      columns: [
        {
          type: 'selection',
          width: '55',
        },
        {
          key: 'stem',
          title: '题干',
          showTooltip: true,
        },
        {
          key: 'id',
          title: '试题ID',
        },
        {
          key: 'topicType',
          title: '题型',
          render: ({ row }) => {
            if (row.topicType == 1) {
              return <div>单选题</div>;
            } else if (row.topicType == 2) {
              return <div>多选题</div>;
            } else if (row.topicType == 3) {
              return <div>判断题</div>;
            } else if (row.topicType == 4) {
              return <div>填空题</div>;
            } else if (row.topicType == 5) {
              return <div>主观题</div>;
            }
          },
        },
        {
          key: 'labelName',
          title: '试题标签',
        },
        {
          key: 'categoryName',
          title: '试题分类',
        },
        {
          key: 'difficulty',
          title: '难度',
          render: ({ row }) => {
            if (row.difficulty == 1) {
              return <div>简单</div>;
            } else if (row.difficulty == 2) {
              return <div>普通</div>;
            } else if (row.difficulty == 3) {
              return <div>困难</div>;
            }
          },
        },
        {
          key: 'creatorName',
          title: '操作人',
        },
        {
          key: 'operatetime',
          title: '最后更新时间',
          width: 180,
        },
        {
          key: '',
          title: '操作',
          render: ({ row }) => {
            return (
              <div>
                <el-link type='primary' class='ml12' onClick={() => editArticle(row)}>
                  编辑
                </el-link>
                <el-link type='danger' style='margin:0 12px' onClick={() => delArticle(row.id)}>
                  删除
                </el-link>
              </div>
            );
          },
        },
      ],
      topicOptions: [
        { label: '单选题', value: 1 },
        { label: '多选题', value: 2 },
        { label: '判断题', value: 3 },
        { label: '填空题', value: 4 },
        { label: '主观题', value: 5 },
      ],
      labelOptions: [],
      tableData: [],
      treeList: [],
      tabsList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      ruleForm: {},
      rules: {
        name: [{ required: true, message: '请输入弹窗名称', trigger: 'blur' }],
        desc: [{ required: true, message: '请输入描述信息', trigger: 'blur' }],
      },
      addVisible: false,
      addExportVisible: false, //批量导入
      sortList: [],
      questionList: [],
      categoryId: '',
      editId: '',
      addCategoryVisible: false,
      categoryTitle: '新建分类',
      categoryName: '',
      tHeader: ['序号', '关键词', '回复内容', '类别'],
      tValue: ['index', 'userTel', 'content', 'sort'],
    };
  },
  mounted() {
    that = this;
    that.getSortList();
    that.getLiveCategory();
    that.getList4Select();
  },
  methods: {
    // changeSort(e) {
    //   console.log(e);
    //   that.currentPage = 1;
    //   switch (parseInt(e)) {
    //     case 1: //资源
    //       that.columns = [
    //         {
    //           type: 'index',
    //           title: '序号',
    //         },
    //         {
    //           key: 'id',
    //           title: '资源编号',
    //         },
    //         {
    //           key: 'textName',
    //           title: '资源名称',
    //         },
    //         {
    //           key: 'bgUserName',
    //           title: '操作人',
    //         },
    //         {
    //           key: 'updateDate',
    //           title: '发布时间',
    //         },
    //       ];
    //       that.getCourseList();
    //       break;
    //     case 2: //题库
    //       that.columns = [
    //         {
    //           type: 'index',
    //           title: '序号',
    //         },
    //         {
    //           key: 'id',
    //           title: '题库编号',
    //         },
    //         {
    //           key: 'textName',
    //           title: '题库名称',
    //         },
    //         {
    //           key: 'bgUserName',
    //           title: '操作人',
    //         },
    //         {
    //           key: 'updateDate',
    //           title: '发布时间',
    //         },
    //       ];
    //       that.getList4class();
    //       break;
    //   }
    // },
    //节点拖动
    handleDragEnd(draggingNode, dropNode) {
      console.log('节点拖动', draggingNode.label, dropNode.label);
      that.saveClassification(draggingNode.data.value, draggingNode.data.label, dropNode.data.value);
    },
    //节点点击
    getNodeIds(id) {
      this.ruleForm.categoryId = id;
      that.getList();
      // console.log(id);
      // that.categoryId = id;
      // that.changeSort(parseInt(that.sortVal));
    },
    // 添加/修改文章分类
    saveClassification(id, name, parentId) {
      console.log('before', id, name, parentId);
      parentId = id == parentId ? 0 : parentId;
      let info = {
        id, //分类id
        name, //分类名称
        parentId, //父节点ID
        type: 2,
      };
      var data = encrypt(JSON.stringify(info));
      zgAddCategory(data).then((res) => {
        if (res.result == 1) {
          that.$refs.sortLabel.closeDialog();
          that.$message({
            showClose: true,
            message: '添加成功',
            type: 'success',
          });
          that.getLiveCategory();
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    // 创建标签
    createTagEvent(obj) {
      that.saveClassification(obj.id, obj.name, obj.parentId);
    },
    //删除标签
    delLabel(id) {
      console.log('删除标签', id);
      that
        .$confirm('确认要删除此标签吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let info = {
            id, //分类id
            type: 2,
          };
          var data = encrypt(JSON.stringify(info));
          zgDeleteCategory(data).then((res) => {
            if (res.result == 1) {
              that.$message({
                showClose: true,
                message: '删除成功',
                type: 'success',
              });
              that.getLiveCategory();
            } else {
              that.$message({
                showClose: true,
                message: res.msg,
                type: 'warning',
              });
            }
          });
        });
    },
    // 重置
    resetList() {
      that.ruleForm = {};
      that.currentPage = 1;
      that.sendTime = null;
      that.getList();
    },
    onSelectionChange(val) {
      console.log('val', val);
      // this.tabsList = val;
      if (that.isChange || val.length == 0) {
        return;
      }
      that.delData = subtractArrays(that.tableData, val);
      let allArr = uniqueBy(that.tableData.concat(that.tabsList), 'id');
      that.tabsList = subtractArrays(allArr, that.delData);
    },
    // 新增试题
    addOneQuestions() {
      this.$router.push('./addQuestion');
    },
    // 批量录入试题
    enterQuestions() {
      this.$router.push('./enterQuestion');
    },
    // 批量删除试题
    batchDeleteQuestions() {
      const ids = that.tabsList.map((item) => {
        return item.id;
      });
      console.log('ids', ids);
      that
        .$confirm('确认要删除试题吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let info = {
            ids, //分类id
          };
          var data = encrypt(JSON.stringify(info));
          batchDelete(data).then((res) => {
            that.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
            });
            that.getList();
          });
        });
    },
    //批量导入
    getData(results, header) {
      const headerArr = ['序号', '关键词', '回复内容', '类别'];
      for (var index = 0; index < headerArr.length; index++) {
        if (header[index] !== headerArr[index]) {
          this.$message({
            message: '模板错误,请使用本页面模板',
            type: 'error',
          });
          window.location.reload();
          return;
        }
      }
      let arr = [];
      for (let i = 0; i < results.length; i++) {
        var data = {
          categoryId: that.categoryId,
          quickWord: results[i][headerArr[1]],
          replyContent: results[i][headerArr[2]],
        };
        arr.push(data);
      }
      console.log('表格数据', arr);
      let info = arr;
      console.log(info);
      var data = encrypt(JSON.stringify(info));
      addFeedBackCategory(data).then((res) => {
        this.$message({
          showClose: true,
          message: '添加成功',
          type: 'success',
        });
        that.getList();
      });
    },
    exportMore() {
      that.addExportVisible = true;
    },
    setPage() {
      // 重新设置选中状态
      that.$nextTick(() => {
        let selList = [];
        console.log('当前选择数据', that.tabsList);
        that.$refs.multipleTable.$refs.ElTable.clearSelection();
        that.tabsList.forEach((item) => {
          const row = that.tableData.find((row) => row.id === item.id);
          if (row) {
            selList.push(row);
            that.$refs.multipleTable.$refs.ElTable.toggleRowSelection(row, true);
          }
        });
        that.delData = subtractArrays(that.tableData, selList);
        that.$nextTick(() => {
          that.isChange = false;
        });
      });
    },
    // 新建分类
    saveCategory() {
      let info = {
        categoryName: that.categoryName,
        id: that.editId,
        isDelete: 0,
      };
      console.log(info);
      var data = encrypt(JSON.stringify(info));
      addFeedBackCategory(data).then((res) => {
        this.$message({
          showClose: true,
          message: '编辑成功',
          type: 'success',
        });
        that.addCategoryVisible = false;
        that.getSortList();
      });
    },
    //新增分类
    addCategory() {
      that.categoryTitle = '新建分类';
      that.addCategoryVisible = true;
    },
    //编辑分类
    editCategory(obj) {
      console.log(obj, '编辑分类');
      that.categoryTitle = '编辑分类';
      that.categoryName = obj.categoryName;
      that.editId = obj.id;
      that.addCategoryVisible = true;
    },
    //删除分类
    delCategory(obj) {
      console.log(obj, '删除分类');
      that
        .$confirm('选中的分类将被删除,分类中包含的试题将会移动至系统默认分类。您确定要删除已选择的分类吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let info = {
            ...obj,
            isDelete: 1,
          };
          console.log(info);
          var data = encrypt(JSON.stringify(info));
          editFeedBackCategory(data).then((res) => {
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
            });
            that.getSortList();
          });
        });
    },
    // tabs切换
    handleClick(tab) {
      if (tab.index - that.sortList.length == 0) {
        that.addCategory();
        return;
      }
      that.categoryId = that.sortList[tab.index - 0].id;
      that.getList();
    },
    // 切换分页
    onCurrentChange(val) {
      that.isChange = true;
      that.currentPage = val;
      that.getList();
    },
    //获取所有直播分类(树型结构)
    getLiveCategory() {
      let info = {
        type: 2,
      };
      console.log(info);
      var data = encrypt(JSON.stringify(info));
      zgsourceAllCategory(data).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('获取所有直播分类', ress);
          const list = [{ name: '所有试题', id: '' }, ...ress];
          that.questionList = that.listFor(list);
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    listFor(arr) {
      let children = [];
      if (arr != null && arr != '' && arr != undefined) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].childCourseCategory != '' && arr[i].childCourseCategory != null && arr[i].childCourseCategory != undefined) {
            children.push({
              value: arr[i].id,
              label: arr[i].name,
              children: this.listFor(arr[i].childCourseCategory),
            });
          } else {
            children.push({
              value: arr[i].id,
              label: arr[i].name,
              children: this.listFor(arr[i].childCourseCategory),
            });
          }
        }
      } else {
        return;
      }
      return children;
    },
    // 提交表单
    submitForm(formName) {
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let arr = [];
          let data = {};
          let obj = {
            categoryId: that.ruleForm.categoryId,
            quickWord: that.ruleForm.quickWord,
            replyContent: that.ruleForm.replyContent,
            status: that.ruleForm.status == true ? 1 : 0,
          };
          if (that.dialogTitle == '新建关键词') {
            arr.push(obj);
            console.log(arr);
            data = encrypt(JSON.stringify(arr));
            addFeedBackBatch(data).then((res) => {
              if (res.result == 1) {
                console.log(res);
                that.addVisible = false;
                that.currentPage = 1;
                that.getList();
                this.$message({
                  showClose: true,
                  message: '保存成功',
                  type: 'success',
                });
              } else {
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: 'error',
                });
              }
            });
            return;
          }
          obj.id = that.ruleForm.id;
          // info.status = info.status == true ? 1 : 0;
          console.log(obj, '我是表单');
          data = encrypt(JSON.stringify(obj));
          editFeedBack(data).then((res) => {
            if (res.result == 1) {
              console.log(res);
              that.addVisible = false;
              that.currentPage = 1;
              that.getList();
              this.$message({
                showClose: true,
                message: '保存成功',
                type: 'success',
              });
            } else {
              this.$message({
                showClose: true,
                message: res.msg,
                type: 'error',
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getList4Select() {
      let info = {};
      console.log(info);
      var data = encrypt(JSON.stringify(info));
      list4Select(data).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('分类列表]]]]', ress);
          that.labelOptions = ress;
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    //获取分类列表
    getSortList() {
      let info = {};
      console.log(info);
      var data = encrypt(JSON.stringify(info));
      findFeedBackCategory(data).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('分类列表', ress);
          that.sortList = ress.map((item) => {
            return {
              ...item,
              id: item.id + '',
            };
          });
          that.activeName = ress[0].categoryName;
          that.categoryId = ress[0].id + '';
          that.getList();
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    // 编辑按钮
    editArticle(row) {
      console.log('row', row);
      this.$router.push({ path: './addQuestion', query: { id: row.id, topicType: row.topicType, type: 'edit' } });
    },
    //删除按钮
    delArticle(id) {
      that
        .$confirm('确认要删除此项吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let info = {
            id,
          };
          console.log(info);
          var data = encrypt(JSON.stringify(info));
          deleteQuestion(data).then((res) => {
            if (res.result == 1) {
              this.$message({
                showClose: true,
                message: '删除成功',
                type: 'success',
              });
              that.getList();
            } else {
              this.$message({
                message: res.msg,
                type: 'warning',
              });
            }
          });
        });
    },
    getList() {
      that.tableLoading = true;
      let info = {
        page: that.currentPage,
        pageSize: 10,
        ...that.ruleForm,
        label: that.ruleForm.label ? that.ruleForm.label.join(',') : null,
      };
      info.from = that.sendTime ? that.sendTime[0] : null;
      info.to = that.sendTime ? that.sendTime[1] : null;
      console.log('9999', info);
      var data = encrypt(JSON.stringify(info));
      listQuestion(data).then((res) => {
        console.log('res,,,,,....', res);
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('-----列表', ress);
          that.total = ress.total;
          that.currentPage = ress.pageNum;
          that.tableData = ress.list.map((item) => {
            return {
              ...item,
              operatetime: formatDate(new Date(item.operatetime), 'yyyy-MM-dd hh:mm'),
            };
          });
          that.setPage();
          that.tableLoading = false;
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-tabs--border-card {
  height: 100%;
}

/deep/.el-tabs--border-card > .el-tabs__header {
  background-color: transparent;
}

/deep/.el-tabs--left .el-tabs__header.is-left {
  width: 100%;
  margin-right: 0;
}

/deep/.el-tabs--left.el-tabs--border-card .el-tabs__item.is-left {
  text-align: center;
}

/deep/.el-form-item__content {
  margin-left: 0 !important;
}

.el-tabs--border-card > .el-tabs__content {
  display: none;
}

.el-icon-edit {
  display: none;
}

.el-icon-delete {
  display: none;
}

.el-tabs--left.el-tabs--border-card .el-tabs__item.is-left:hover {
  .el-icon-edit {
    display: inline-block;
  }

  .el-icon-delete {
    display: inline-block;
  }
}

.main {
  padding: 12px;

  .main-left {
    flex-shrink: 0;
    width: 200px;
  }

  .main-right {
    flex: 1;
    margin-left: 12px;
    padding: 12px;
  }
}
</style>
